/**
 * The design's toggle: a 48×29 track with a 23px knob, brand when on,
 * the track colour when off. A bare control — the row that owns it
 * supplies the label through `aria-label` or `aria-labelledby`.
 */
export default function Switch({ checked, onToggle, label, labelledBy, className = '' }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      aria-labelledby={labelledBy}
      onClick={onToggle}
      className={`flex h-[29px] w-12 shrink-0 items-center rounded-full p-[3px] transition-colors ${checked ? 'bg-brand-600' : 'bg-track'} ${className}`}
    >
      <span className={`size-[23px] rounded-full bg-white shadow transition-transform ${checked ? '-translate-x-[19px]' : 'translate-x-0'}`} />
    </button>
  )
}
